import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { SCORING } from 'actions/scoring';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${SCORING}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${SCORING}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case SCORING:
      return state.merge({
        loading: false,
        data: action.payload,
        error: null,
      });
    default:
      return state;
  }
};
